import styled from "styled-components";

export const ImageEl = styled.img``